export const EDUCATOR_CONFIRMATION_CODE_RESEND = 'EDUCATOR/EDUCATOR_CONFIRMATION_CODE_RESEND';
